import { Arg, Metadata } from '../../../../utils/spds/metadata';
import CloseButton from '../../action/button/close.gjs';
import FlexColumn from '../../layout/flex/column.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Header for flyout modal with close.',
  meta: {
    close: Arg.action({ description: 'Close action' }).required(),
  },
  name: 'Header',
});

export default class SpdsModalFlyoutHeader extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-flyout-header';

  <template>
    <FlexRow
      @tag="header"
      class={{this.classes}}
      data-test-spds-modal-flyout-header
      {{this.validateArguments}}
      ...attributes
    >
      <FlexColumn>
        <FlexRow
          @tag="h1"
          class="spds-modal-flyout-header-title"
          data-test-spds-modal-flyout-header-title
        >
          {{yield to="title"}}
        </FlexRow>
        <FlexRow
          @tag="p"
          class="spds-modal-flyout-header-description"
          data-test-spds-modal-flyout-header-description
        >
          {{yield to="description"}}
        </FlexRow>
      </FlexColumn>
      <CloseButton
        @close={{@close}}
        class="spds-modal-flyout-close-btn"
        data-test-spds-modal-flyout-close-button
      />
    </FlexRow>
  </template>
}

export const MODAL_FLYOUT_HEADER_METADATA = SpdsModalFlyoutHeader.metadata;
